import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../../../core/domain/Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {CoachHistoryModel} from './CoachHistory.model';

@injectable()
export class CoachHistoryFactory
  implements BaseDomainFactory<CoachHistoryModel, CoachHistoryModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: CoachHistoryModel.Props): CoachHistoryModel {
    return this.modelsRegistry.put(new CoachHistoryModel(props));
  }
}
